import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CORE_ACTION } from './core.actions';
import { tap } from 'rxjs/operators';
import { HeaderAlertService } from '../header-alert';

@Injectable()
export class CoreEffects {
  constructor(private readonly actions$: Actions, private readonly alert: HeaderAlertService) { }

  errors$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CORE_ACTION.GET_MENU_LIST_ERROR, CORE_ACTION.GET_LOCALE_LIST_ERROR),
      tap(() => {
        this.alert.clean();
        this.alert.add({
          type: 'error',
          content: $localize`:@@direct-shared-lib.login-effects.commonErrorServerError:Oops... An error occurred while making a request to the server`
        });
      })
    )
  }, { dispatch: false });
}
